import React from 'react';
import { generateCode, openFicha } from '../utils/fichaUtils';

export default function Step4Success({ code, personalData, processState, onReset }) {
  const dni = personalData?.docNumber || '';
  const epgCode = generateCode(dni);

  const handleDescargarFicha = () => {
    const now = new Date();
    const fecha = now.toLocaleDateString('es-PE', { year: 'numeric', month: 'long', day: 'numeric' })
      + ', ' + now.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' });

    openFicha({
      epgCode,
      apiCode: code || '',
      nombre: personalData?.name || '',
      apellidos: `${personalData?.paternal || ''} ${personalData?.maternal || ''}`.trim(),
      dni,
      email: personalData?.email || '',
      cell: personalData?.cell || '',
      programa: processState?.programLabel || '',
      proceso: processState?.processLabel || '',
      fecha,
    });
  };

  return (
    <div className="card success-screen">
      <div className="success-anim">✓</div>
      <h2 className="success-title">¡Inscripción Registrada!</h2>
      <p className="success-sub">
        Su postulación ha sido registrada exitosamente en el sistema EPG–UNSM.
      </p>
      <div className="success-code-box">
        <div className="success-code-label">Código EPG</div>
        <div className="success-code">{epgCode}</div>
      </div>
      <p className="success-note">
        Guarde este código. Puede descargar su ficha de registro como comprobante.
      </p>
      <p className="success-note" style={{ color: '#b45309', fontSize: '0.82rem', marginTop: '-8px' }}>
        ⚠ La ficha es solo evidencia de registro. La información será evaluada por la EPG–UNSM.
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button className="btn-primary" onClick={handleDescargarFicha}>
          🖨 Descargar Ficha de Registro
        </button>
        <button className="btn-ghost" onClick={onReset}>
          + Nueva Inscripción
        </button>
      </div>
    </div>
  );
}
